export const mutations = {
    ADD_ITEM(state, item) {
      state.items.push(item);
      localStorage.setItem('cartItems', JSON.stringify(state.items));
    },
    REMOVE_ITEM(state, itemId) {
      state.items = state.items.filter(item => item.id !== itemId);
      localStorage.setItem('cartItems', JSON.stringify(state.items));
    },
    CLEAR_CART(state) {
      state.items = [];
      localStorage.removeItem('cartItems');
    }
  };
  